// extracted by mini-css-extract-plugin
module.exports = {"outline":"toggleSwitch_outline__FY9vU"};